import Axios from "axios";
import {ConfEnv} from "../../config/config";

/**
 * Calls the shared backend Google sign-in endpoint.
 *
 * Login-only flow: existing Google users are authenticated and the backend
 * returns a Keycloak JWT under `data.data.access_token`. New users get an
 * error whose body carries a `code` (e.g. `verification_required`) that the
 * caller surfaces to prompt a regular registration.
 *
 * A bare axios call is used (instead of the shared publicRequest wrapper) so
 * the backend `code` field is preserved for the caller; the shared response
 * interceptor reduces errors to their message only.
 *
 * @param {{idToken: string}} params Google ID token (JWT) from the credential response.
 * @returns {Promise<{data: object, status: number}>} Backend envelope `{message, status, data}`.
 */
export const googleLoginService = async ({idToken}) => {
  try {
    const response = await Axios.post(
      ConfEnv.API_URL.URL_GOOGLE_LOGIN,
      {id_token: idToken},
      {headers: {"Content-Type": "application/json"}}
    );
    const {data, status} = response;
    return {data, status};
  } catch (err) {
    if (!err.response) {
      throw new Error("networkError");
    }

    const responseData = err.response.data ?? {};
    const error = new Error(responseData.message || "internalError");
    error.code = responseData.code;
    error.status = err.response.status;
    throw error;
  }
};
